/**
 * Admin referrals desk — must match betMateBackEnd REFERRAL_UNLOCK_SCORE.
 */
export const REFERRAL_UNLOCK_SCORE = 100;

export const REFERRAL_UNLOCK_RULE_SHORT = `${REFERRAL_UNLOCK_SCORE} all-time score + at least one bet`;

export const REFERRAL_DESK_VIEWS = [
  { id: "all", label: "All referrals", hint: "Full program" },
  { id: "pending", label: "Pending", hint: "Awaiting unlock" },
  { id: "ready", label: "Ready to claim", hint: `${REFERRAL_UNLOCK_SCORE} all-time score + bet` },
  { id: "rewarded", label: "Claimed", hint: "Rewards credited" },
  { id: "cancelled", label: "Cancelled", hint: "Voided referrals" },
];

export const REFERRAL_STATUS_FILTERS = [
  { value: "all", label: "Any status" },
  { value: "pending", label: "Pending" },
  { value: "rewarded", label: "Rewarded" },
  { value: "cancelled", label: "Cancelled" },
];

export const REFERRAL_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "progress", label: "Closest to unlock" },
  { value: "amount", label: "Largest reward" },
  { value: "referrer", label: "Referrer name" },
];

export function sortReferrals(referrals = [], sortKey = "newest") {
  const list = [...referrals];
  switch (sortKey) {
    case "oldest":
      return list.sort(
        (a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
      );
    case "amount":
      return list.sort((a, b) => (Number(b.rewardAmount) || 0) - (Number(a.rewardAmount) || 0));
    case "progress":
      return list.sort((a, b) => (Number(b.progressPercent) || 0) - (Number(a.progressPercent) || 0));
    case "referrer":
      return list.sort((a, b) =>
        String(a.referrer?.name || "").localeCompare(String(b.referrer?.name || ""))
      );
    default:
      return list.sort(
        (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
      );
  }
}

export function clientFilterReferrals(referrals = [], search = "") {
  const q = search.trim().toLowerCase();
  if (!q) return referrals;
  return referrals.filter((item) => {
    const hay = [
      item.referrer?.name,
      item.referrer?.contact,
      item.referrer?.inviteCode,
      item.referee?.name,
      item.referee?.contact,
      item.referralCode,
      item.status,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}
